import {ChoiceValueDecisionState, ConfigurationInterpreter} from '@viamedici-spc/configurator-ts';
import {stringToAttributeId} from '../components/spc/util/spcUtils';
import {globalAttributeIdKeyBuilderFromCondition} from './globalAttributeIdKeyBuilderFromCondition';

export function genericConditional(spcConfiguration, conditionalArray) {
	if (conditionalArray === null) {return null;}

	//console.log('genericConditional', conditionalArray);
	if (spcConfiguration && conditionalArray) {
		const matchingValues = conditionalArray
			.filter(conditionalItem => conditionalItem.Conditions.length > 0)
			.filter(conditionalItem => conditionalItem.Conditions.reduce(
				(match, condition) => {
					const key = globalAttributeIdKeyBuilderFromCondition(condition.AttributeReference.GlobalAttributeId);
					//console.log('condition', condition, key);
					const choiceValue = ConfigurationInterpreter.getChoiceValue(
						spcConfiguration,
						key,
						condition.ValueId
					);
					//console.log('choiceValue', key, condition.key, condition.value, choiceValue, choiceValue?.decision?.state === ChoiceValueDecisionState.Included);
					return choiceValue?.decision?.state === ChoiceValueDecisionState.Included && match;
				}, true
			));
		//console.log('genericConditional matchingValues', matchingValues);

		if (matchingValues.length > 0) {
			return matchingValues;
		}
	}
	return null;
}



export function conditional(spcConfiguration, conditionalVariantValues, id, type = 'EditorialTable', side = 1) {
	if (conditionalVariantValues === null) {return null;}
	//console.log('conditional ', id, type, side);
	const conditionalValues = getConditionalVariantValue(spcConfiguration, conditionalVariantValues, id, type, side);
	//console.log('conditionalValues', conditionalValues);

	if (conditionalValues && conditionalValues.length > 0) {
		//console.log('match: ', id, conditionalValues[0].value);
		return conditionalValues[0].value;
	} else {
		//console.log('no match: ', id, conditionalValues, conditionalVariantValues);
		return null;
	}
}
export function conditionalWithConditions(conditions, conditionalVariantValues, id, type = 'EditorialTable', side = 1) {
	if (conditionalVariantValues === null) {return null;}
	const conditionalValues = getConditionalVariantValueStaticConditions(conditions, conditionalVariantValues, id, type, side);
	if (conditionalValues && conditionalValues.length > 0) {
		//console.log(' match: ', id, conditionalValues[0].value, conditionalValues);
		return conditionalValues[0].value;
	} else {
		//console.log('no match: ', id, conditionalValues, conditions);
		return null;
	}
}
export function conditionals(spcConfiguration, conditionalVariantValues, id, type = 'EditorialTable', side = null) {
	let conditionalValues;
	if (side === null) {
		conditionalValues = [
			...getConditionalVariantValue(spcConfiguration, conditionalVariantValues, id, type, 1) ?? [],
			...getConditionalVariantValue(spcConfiguration, conditionalVariantValues, id, type, 2) ?? []
		];
	} else {
		conditionalValues = getConditionalVariantValue(spcConfiguration, conditionalVariantValues, id, type, side);
	}
	return conditionalValues;
}

function getConditionalVariantValue(spcConfiguration, conditionalVariantValues, id, type, side = 1) {
	if (conditionalVariantValues === null) { return null; }

	// WORKAROUND: Remove 'RETURN_' from id
	id = id.replace('REDTAB.RETURN_', '').replace('RETURN_', '');
	// collect all values where id and decisions match
	const key = type + '.' + id + '.' + side;
	//console.log('getConditionalVariantValue key', key);
	if (spcConfiguration && conditionalVariantValues && key in conditionalVariantValues) {
		const matchingValues = conditionalVariantValues[key].filter(
			conditionalVariantValue => conditionalVariantValue.conditions.reduce(
				(match, condition) => {
					const choiceValue = ConfigurationInterpreter.getChoiceValue(
						spcConfiguration,
						condition.key,
						condition.value
					);
					//console.log('choiceValue', key, condition.key, condition.value, choiceValue, choiceValue?.decision?.state === ChoiceValueDecisionState.Included);
					return choiceValue?.decision?.state === ChoiceValueDecisionState.Included && match;
				}, true
			));
		//console.log('matchingValues', matchingValues);

		// go through matchingValues, if the object is the same, only return one distinct value for them
		const distinctMatchingValues = matchingValues.filter((value, index, self) =>
			index === self.findIndex(t => (
				t.conditions.every(condition => value.conditions.some(v => v.key === condition.key && v.value === condition.value))
			))
		);
		// console.log('distinctMatchingValues', distinctMatchingValues);

		if (distinctMatchingValues.length > 0) {
			return distinctMatchingValues;
		}
	}
	return null;
}
function getConditionalVariantValueStaticConditions(conditions, conditionalVariantValues, id, type, side = 1) {
	if (conditionalVariantValues === null) {
		return null;
	}

	// WORKAROUND: Remove 'RETURN_' from id
	id = id.replace('REDTAB.RETURN_', '').replace('RETURN_', '');
	// collect all values where id and decisions match
	const key = type + '.' + id + '.' + side;
	if (conditions && key in conditionalVariantValues) {
		const matchingValues = conditionalVariantValues[key].filter(
			conditionalVariantValue => conditionalVariantValue.conditions.every(a => conditions.includes(a)));

		if (matchingValues.length > 0) {
			return matchingValues;
		}
	}
	return null;
}
